import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyleSheet } from "react-native";
import { ActivityIndicator, useTheme } from "react-native-paper";
import { Stack } from "../../components/layout/stack";
import { Screen } from "../../components";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { ThemeType } from "../../theme/theme";
import { RootState } from "../../redux/reducers";
import { InfoBox, Text } from "../../components";
import { InfoBoxIconType, InfoBoxType } from "../../enums";
import { ServiceCard } from "../../components/service-card/service-card";
import { useReservationInformation } from "../../hooks/useReservationInformation";
import { translate } from "../../i18n";

export const ServiceRequestHome = () => {
  const navigation = useNavigation();
  const theme = useTheme() as ThemeType;
  const { spacing } = theme;
  const styles = getStyles(theme);
  const { reservations: allReservations, hasError } = useReservationInformation();
  const [reservations, setReservations] = useState<any>(allReservations);
  const [isLoading, setLoading] = useState<boolean>();
  const logger = useSelector((state: RootState) => state.logger);
  const hasReservations = reservations && reservations.length;
  const isResident = useSelector((state: RootState) => state.userRole.isResident);

  useEffect(() => {
    if (allReservations?.length || isResident === false || hasError) {
      setLoading(false);
      const reservationsWithServiceRequests = allReservations.filter(
        ({ allowServiceRequests }: any) => allowServiceRequests
      );
      setReservations(reservationsWithServiceRequests);
    } else {
      setLoading(true);
    }
  }, [allReservations, isResident, hasError]);

  return (
    <Screen style={styles.container} preset="scroll" dontUseAutoPadding>
      {isLoading ? (
        <ActivityIndicator style={{ paddingVertical: spacing.large }} />
      ) : hasError ? (
        <InfoBox
          headline={translate("homeStack.reservationErrorTitle")}
          headlineIconType={InfoBoxIconType.RED_X}
          infoBoxType={InfoBoxType.RED}>
          <Text tx="homeStack.reservationErrorMessage" />
        </InfoBox>
      ) : hasReservations ? (
        <Stack style={{ alignItems: "center", marginHorizontal: spacing.smaller }}>
          {reservations.map((reservation: any) => (
            <ServiceCard {...reservation} key={reservation.id} navigation={navigation} />
          ))}
        </Stack>
      ) : null}
    </Screen>
  );
};

const getStyles = (theme: ThemeType) => {
  const { colors, spacing } = theme;
  return StyleSheet.create({
    container: {
      paddingTop: spacing.medium,
    },
  });
};
